var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgR3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 90,
    height: 90,
    rx: 45,
    fill: "url(#paint0_linear_282_4403)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 57.5H60.5V27.5C60.5 27.1022 60.342 26.7206 60.0607 26.4393C59.7794 26.158 59.3978 26 59 26H48.5C48.1022 26 47.7206 26.158 47.4393 26.4393C47.158 26.7206 47 27.1022 47 27.5V35H38C37.6022 35 37.2206 35.158 36.9393 35.4393C36.658 35.7206 36.5 36.1022 36.5 36.5V44H29C28.6022 44 28.2206 44.158 27.9393 44.4393C27.658 44.7206 27.5 45.1022 27.5 45.5V57.5H26C25.6022 57.5 25.2206 57.658 24.9393 57.9393C24.658 58.2206 24.5 58.6022 24.5 59C24.5 59.3978 24.658 59.7794 24.9393 60.0607C25.2206 60.342 25.6022 60.5 26 60.5H62C62.3978 60.5 62.7794 60.342 63.0607 60.0607C63.342 59.7794 63.5 59.3978 63.5 59C63.5 58.6022 63.342 58.2206 63.0607 57.9393C62.7794 57.658 62.3978 57.5 62 57.5ZM50 29H57.5V57.5H50V29ZM39.5 38H47V57.5H39.5V38ZM30.5 47H36.5V57.5H30.5V47Z",
    fill: "#FFFADD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_282_4403",
    x1: 0,
    y1: 45.5,
    x2: 90,
    y2: 45.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#776D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463C01"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR3);
export default __webpack_public_path__ + "static/media/r-3.345470aaec07b392c6536e52935f71e3.svg";
export { ForwardRef as ReactComponent };